import { t } from '@lingui/core/macro';
import { useField, useFormikContext } from 'formik';
import { ROOT } from 'app/domains/filesystem/utils/constants';
import { UploadOptions } from 'app/domains/upload/UploadOptions';
export function DocumentOptions(props) {
    const { folder } = props;
    const { isSubmitting } = useFormikContext();
    const [, , folderHelpers] = useField('parentId');
    const [projectsField, , projectsHelpers] = useField('projects');
    const [autoTagField, , autoTagHelpers] = useField({
        name: 'autoTag',
        type: 'checkbox',
    });
    const getFolder = () => {
        if (folder) {
            return folder;
        }
        // `folder === null` means that Root is selected
        if (folder === null) {
            return {
                id: ROOT,
                name: t({
                    message: 'Root',
                    comment: 'Root folder label',
                }),
            };
        }
        return undefined;
    };
    const handleSelectFolder = (newFolder) => {
        folderHelpers.setValue(newFolder.id);
    };
    const handleSelectProjects = (projects) => {
        projectsHelpers.setValue(projects);
    };
    const handleChangeAutoTag = (value) => {
        autoTagHelpers.setValue(value);
    };
    return (<UploadOptions disabled={isSubmitting} folder={getFolder()} projects={projectsField.value} autoTag={autoTagField.value} onSelectFolder={handleSelectFolder} onChangeProjects={handleSelectProjects} onChangeAutoTag={handleChangeAutoTag}/>);
}
